export const durationFormatted = (totalMinutes: number) => {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return `${ hours }h ${ minutes }m`;
};
